import React from 'react';

const SubNavTab = ({ title, iconClassName, onClick, selected }) => {
  let classes = ['sub-nav-tab'];
  let content;

  if (iconClassName) {
    content = (
      <a onClick={ onClick }>
        <span
          className="icon is-small">
          <i
            className={ iconClassName }
            aria-hidden="true" />
        </span>
        <span>{ title }</span>
      </a>
    );
  } else {
    content = (
      <a onClick={ onClick }>
        <span>{ title }</span>
      </a>
    );
  }

  if (selected) {
    classes.push('is-active');
  }

  return (
    <li className={ classes.join(' ') }>
      { content }
    </li>
  );
}

export default SubNavTab;


// WEBPACK FOOTER //
// ./src/components/sub-nav-tab/sub-nav-tab.js